module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"all":"所有评论","range":{"over":"{value} {unit} 以上","under":"{value} {unit} 以下","between":"{start} - {end} {unit}"}}}')
  delete Component.options._Ctor
}
